import type { FunctionComponent } from 'react';
import type { TypeConditionalWrapperProps } from './types';

/**
 * ConditionalWrapper
 */
 
// @ts-ignore
export const ConditionalWrapper: FunctionComponent<
  TypeConditionalWrapperProps
> = ({ condition, wrapper, children }: TypeConditionalWrapperProps) =>
  condition ? wrapper(children) : children;

ConditionalWrapper.displayName = 'ConditionalWrapper';
